import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useAuth } from "../../AuthContext";

import {
  FaCalendarAlt,
  FaCalendarCheck,
  FaCashRegister,
  FaChartLine,
  FaUserMd,
  FaBuilding,
  FaUserFriends,
  FaClipboardList,
  FaList,
  FaShoppingCart,
  FaHistory,
  FaArrowRight,
} from "react-icons/fa";

import "./Dashboard.css";

const Dashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [expandedCard, setExpandedCard] = useState(null);

  // Função para verificar permissões do usuário
  const temPermissao = (modulo, acao = "visualizar") => {
    if (user?.tipo === "administrator") return true;
    if (user?.modulos && user.modulos[modulo]) {
      return user.modulos[modulo][acao] || false;
    }
    return false;
  };

  // Cards de Atalhos Rápidos
  const atalhosPrincipais = [
    {
      id: "reserva",
      titulo: "Reservas",
      descricao: "Solicitações de agenda",
      icone: <FaCalendarAlt style={{ fontSize: "2rem", color: "#fff" }} />,
      rota: "/painel/reserva",
      cor: "#B83732", // Vermelho principal
      permissoes: ["administrator", "editor"],
      corGradiente: "linear-gradient(135deg, #B83732 0%, #D65A55 100%)",
    },
    {
      id: "agenda",
      titulo: "Agenda",
      descricao: "Visualizar compromissos",
      icone: <FaCalendarCheck style={{ fontSize: "2rem", color: "#fff" }} />,
      rota: "/painel/agenda",
      cor: "#E67E22", // Laranja
      permissoes: ["administrator", "editor"],
      corGradiente: "linear-gradient(135deg, #E67E22 0%, #F39C12 100%)",
    },
    {
      id: "caixa",
      titulo: "Caixa",
      descricao: "Gerenciar pagamentos",
      icone: <FaCashRegister style={{ fontSize: "2rem", color: "#fff" }} />,
      rota: "/painel/caixa",
      cor: "#27AE60", // Verde
      permissoes: ["administrator", "editor"],
      corGradiente: "linear-gradient(135deg, #27AE60 0%, #2ECC71 100%)",
    },
    {
      id: "relatorios",
      titulo: "Relatorios",
      descricao: "Despesas e receitas",
      icone: <FaChartLine style={{ fontSize: "2rem", color: "#fff" }} />,
      rota: "/painel/Relatorios",
      cor: "#8E44AD", // Roxo
      permissoes: ["administrator", "editor"],
      corGradiente: "linear-gradient(135deg, #8E44AD 0%, #9B59B6 100%)",
    },
  ];

  const atalhosSecundarios = [
    {
      id: "pacientes",
      titulo: "Pacientes",
      descricao: "Cadastro e histórico",
      icone: <FaUserFriends style={{ fontSize: "1.5rem", color: "#fff" }} />,
      rota: "/painel/pacientes",
      cor: "#3498DB", // Azul
      permissoes: ["administrator", "editor"],
    },
    {
      id: "profissionais",
      titulo: "Profissionais",
      descricao: "Equipe e especialidades",
      icone: <FaUserMd style={{ fontSize: "1.5rem", color: "#fff" }} />,
      rota: "/painel/profissionais",
      cor: "#1ABC9C", // Turquesa
      permissoes: ["administrator", "editor"],
    },
    {
      id: "servicos",
      titulo: "Serviços",
      descricao: "Procedimentos e valores",
      icone: <FaList style={{ fontSize: "1.5rem", color: "#fff" }} />,
      rota: "/painel/servicos",
      cor: "#F1C40F", // Amarelo
      permissoes: ["administrator", "editor"],
    },
    {
      id: "empresas",
      titulo: "Empresas",
      descricao: "Unidades e filiais",
      icone: <FaBuilding style={{ fontSize: "1.5rem", color: "#fff" }} />,
      rota: "/painel/empresas",
      cor: "#E74C3C", // Vermelho claro
      permissoes: ["administrator"],
    },
    {
      id: "pedidos",
      titulo: "Pedidos",
      descricao: "Ordens de serviço",
      icone: <FaClipboardList style={{ fontSize: "1.5rem", color: "#fff" }} />,
      rota: "/painel/pedidos",
      cor: "#95A5A6", // Cinza
      permissoes: ["administrator", "editor"],
    },
  ];

  const handleCardClick = (rota) => {
    navigate(rota);
  };

  return (
    <div
      style={{
        fontFamily: "'Rajdhani', sans-serif",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      {/* Barra superior vermelha */}
      <div
        style={{
          backgroundColor: "#B83732",
          height: "80px",
          minHeight: "40px",
          width: "100%",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          fontWeight: "bold",
          position: "fixed", // Mudado de "relative" para "fixed"
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1, 
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* lado esquerdo */}
        <div></div>

        {/* Centro */}
        <div></div>

        {/* lado direito */}
        <div></div>
      </div>

      {/* Espaçador para compensar a barra fixa */}
      <div style={{ height: "40px" }} />

      {/* Header do Dashboard */}
      <div
        className="dashboard-container"
        style={{
          fontFamily: "'Rajdhani', sans-serif",
          padding: "25px",
          flex: 1, // Isso faz o conteúdo crescer
          backgroundColor: "#f5f5f5",
        }}
      >
        <div
          style={{
            marginBottom: "30px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "15px",
          }}
        >
          <div>
            <h1
              style={{
                fontSize: "2rem",
                fontWeight: "700",
                color: "#2c3e50",
                margin: "0 0 5px 0",
                letterSpacing: "-0.5px",
              }}
            >
              Olá, {user?.nome || "Usuário"}!
            </h1>
            <p
              style={{
                fontSize: "1rem",
                color: "#7f8c8d",
                margin: 0,
              }}
            >
              Bem-vindo ao painel de controle. Selecione uma opção para começar.
            </p>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <span
              style={{
                backgroundColor: "#fff",
                padding: "8px 15px",
                borderRadius: "20px",
                fontSize: "0.9rem",
                fontWeight: "500",
                color: "#2c3e50",
                boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
              }}
            >
              <i className="pi pi-calendar" style={{ marginRight: "8px" }}></i>
              {new Date().toLocaleDateString("pt-BR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </span>
          </div>
        </div>

        {/* Cards Principais */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px",
            marginBottom: "40px",
          }}
        >
          {atalhosPrincipais.map(
            (card) =>
              temPermissao(card.id, "visualizar") && (
                <div
                  key={card.id}
                  onClick={() => handleCardClick(card.rota)}
                  onMouseEnter={() => setExpandedCard(card.id)}
                  onMouseLeave={() => setExpandedCard(null)}
                  style={{
                    background: card.corGradiente,
                    borderRadius: "15px",
                    padding: "25px 20px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow:
                      expandedCard === card.id
                        ? "0 10px 25px rgba(0,0,0,0.2)"
                        : "0 5px 15px rgba(0,0,0,0.1)",
                    transform:
                      expandedCard === card.id
                        ? "translateY(-5px)"
                        : "translateY(0)",
                    color: "#fff",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  {/* Efeito de brilho */}
                  <div
                    style={{
                      position: "absolute",
                      top: "-50%",
                      right: "-50%",
                      width: "200%",
                      height: "200%",
                      background:
                        "radial-gradient(circle, rgba(255,255,255,0.2) 0%, transparent 70%)",
                      opacity: expandedCard === card.id ? 0.3 : 0,
                      transition: "opacity 0.3s ease",
                      pointerEvents: "none",
                    }}
                  />

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "rgba(255,255,255,0.2)",
                        borderRadius: "12px",
                        padding: "12px",
                        display: "inline-flex",
                      }}
                    >
                      {card.icone}
                    </div>
                    <FaArrowRight
                      style={{
                        fontSize: "1.2rem",
                        opacity: expandedCard === card.id ? 1 : 0.5,
                        transition: "opacity 0.3s ease",
                      }}
                    />
                  </div>

                  <h3
                    style={{
                      fontSize: "1.5rem",
                      fontWeight: "600",
                      margin: "0 0 5px 0",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {card.titulo}
                  </h3>

                  <p
                    style={{
                      fontSize: "0.9rem",
                      margin: 0,
                      opacity: 0.9,
                      lineHeight: "1.4",
                    }}
                  >
                    {card.descricao}
                  </p>
                </div>
              ),
          )}
        </div>

        {/* Seção de Módulos */}
        <div style={{ marginBottom: "30px" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
              gap: "15px",
            }}
          >
            {atalhosSecundarios.map(
              (card) =>
                temPermissao(card.id, "visualizar") && (
                  <div
                    key={card.id}
                    onClick={() => handleCardClick(card.rota)}
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      padding: "20px 15px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      border: "1px solid #e8e8e8",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                      "&:hover": {
                        boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                        transform: "translateY(-2px)",
                      },
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow =
                        "0 5px 15px rgba(0,0,0,0.1)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow =
                        "0 2px 8px rgba(0,0,0,0.04)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: card.cor,
                        borderRadius: "10px",
                        padding: "10px",
                        display: "inline-flex",
                      }}
                    >
                      {card.icone}
                    </div>
                    <div>
                      <h4
                        style={{
                          fontSize: "1rem",
                          fontWeight: "600",
                          color: "#2c3e50",
                          margin: "0 0 3px 0",
                        }}
                      >
                        {card.titulo}
                      </h4>
                      <p
                        style={{
                          fontSize: "0.8rem",
                          color: "#7f8c8d",
                          margin: 0,
                        }}
                      >
                        {card.descricao}
                      </p>
                    </div>
                  </div>
                ),
            )}
          </div>
        </div>

        {/* Cards de Informação Rápida */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "15px",
            marginTop: "30px",
            marginBottom: "30px", // Adicionado margem inferior
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              padding: "15px",
              border: "1px solid #e8e8e8",
              boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaHistory style={{ color: "#B83732", fontSize: "1.2rem" }} />
              <span style={{ fontSize: "0.9rem", color: "#7f8c8d" }}>
                Último acesso
              </span>
            </div>
            <p
              style={{
                fontSize: "1rem",
                fontWeight: "500",
                color: "#2c3e50",
                margin: "5px 0 0 0",
              }}
            >
              {new Date().toLocaleString("pt-BR")}
            </p>
          </div>

          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              padding: "15px",
              border: "1px solid #e8e8e8",
              boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaUserMd style={{ color: "#27AE60", fontSize: "1.2rem" }} />
              <span style={{ fontSize: "0.9rem", color: "#7f8c8d" }}>
                Perfil
              </span>
            </div>
            <p
              style={{
                fontSize: "1rem",
                fontWeight: "500",
                color: "#2c3e50",
                margin: "5px 0 0 0",
              }}
            >
              {user?.tipo === "administrator" ? "Administrador" : "Editor"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;